import {Component, OnInit, ViewChild} from '@angular/core';
import {BehaviorSubject} from 'rxjs/BehaviorSubject';
import {Observable} from 'rxjs/Observable';
import {DatagridSearchComponent} from './datagrid-search.component';
import {DatagridListComponent} from './datagrid-list.component';
import {RequestParams} from '@ngx-ivengi/crud';

@Component({
  selector: 'app-datagrid',
  templateUrl: './datagrid.component.html'
})
export class DatagridBaseComponent implements OnInit {

  public searchEnabled: boolean = false;
  public requestParams: RequestParams = new RequestParams();
  public searchInitialized: Observable<boolean>;

  @ViewChild(DatagridSearchComponent)
  protected datagridSearchComponent: DatagridSearchComponent;

  @ViewChild(DatagridListComponent)
  protected datagridListComponent: DatagridListComponent;

  ngOnInit() {
    // this.requestParams.pagination.limit = 0;

    // perform all configuration for the viewchildren here.
    if(this.searchEnabled) {
      this.datagridSearchComponent.setConfigured();
      this.searchInitialized = this.datagridSearchComponent.initialized;
    } else {
      this.searchInitialized = new BehaviorSubject(true);
    }
    this.datagridListComponent.setConfigured();
  }

  // called by the DatagridSearchComponent
  public doFilter() {
    this.datagridListComponent.doFilter();
  }
}



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/brands-compart-portal-frontend/checkout/src/app/components/datagrid/datagrid.component.ts